export default __webpack_public_path__ + "static/media/Foto galerija 17.8599c13a.jpg";